<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxshortName">Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="quarter">Quarter</label>
                    <input id="quarter" type="number" class="form-control" [(ngModel)]="target.quarter" name="quarter" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="year">Year</label>
                    <input id="year" type="number" class="form-control" [(ngModel)]="target.year" name="year" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="startDate">Start Date</label>
                    <wj-input-date [(ngModel)]="target.startDate" name="startDate"></wj-input-date>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="endDate">End Date</label>
                    <wj-input-date [(ngModel)]="target.endDate" name="endDate"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
